<template>

    <!-- Ec breadcrumb start -->
    <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row ec_breadcrumb_inner">
                        <div class="col-md-6 col-sm-12">
                            <h2 class="ec-breadcrumb-title">{{ item?.title }}</h2>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <!-- ec-breadcrumb-list start -->
                            <ul class="ec-breadcrumb-list">
                                <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>

                                <li class="ec-breadcrumb-item">
                                    <router-link :to="{name: 'blog_posts.index', params: { lang : $i18n.locale }}" >
                                        {{ $t('Blog') }}
                                    </router-link>
                                </li>

                                <li class="ec-breadcrumb-item active">{{ item?.title }}</li>
                            </ul>
                            <!-- ec-breadcrumb-list end -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Ec breadcrumb end -->

    <!-- Ec Blog page -->
    <section class="ec-page-content section-space-p">
        <div class="container">
            <div class="row">
                <div class="ec-blogs-rightside col-lg-12 col-md-12">

                    <!-- Blog content Start -->
                    <div class="ec-blogs-content">
                        <div class="row">
                            <div class="col-md-4">
                                <img class="blog-image w-100" :src="item.image" alt="Blog"/>
                                <div class="ec-blog-date d-flex">
                                    <p class="date ms-auto text-muted">تاريخ المقال : {{ item.created_at }}</p>
                                </div>
                            </div>

                            <div class="col-md-8" v-html="item?.content">

                            </div>
                            <!--                            <div class="ec-blog-tags">-->
                            <!--                                <a href="blog-left-sidebar.html">lifestyle ,</a>-->
                            <!--                                <a href="blog-left-sidebar.html">Outdoor ,</a>-->
                            <!--                                <a href="blog-left-sidebar.html">interior ,</a>-->
                            <!--                                <a href="blog-left-sidebar.html">sports ,</a>-->
                            <!--                                <a href="blog-left-sidebar.html">bloging ,</a>-->
                            <!--                                <a href="blog-left-sidebar.html">inspiration</a>-->
                            <!--                            </div>-->
                            <!--                            <div class="ec-blog-arrows">-->
                            <!--                                <a href="blog-detail-left-sidebar.html"><i class="ecicon eci-angle-left"></i> Prev-->
                            <!--                                    Post</a>-->
                            <!--                                <a href="blog-detail-left-sidebar.html">Next Post <i-->
                            <!--                                    class="ecicon eci-angle-right"></i></a>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                    <!--Blog content End -->
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    data() {
        return {
            item: []
        }
    },
    created() {

        const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

        axios.get(`blog_posts/${this.$route.params.id}`, {}).then(response => {

            this.item = response.data.data;

            toast.dismiss(id);
        }, response => {
            toast.dismiss(id);
        });
    },
}
</script>
